import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Spinner, Heading, Text, VStack, Button } from 'native-base';

export type MlRuntimeInstallStage = 'checking' | 'staging' | 'extracting' | 'done' | 'error';

interface MlRuntimeSetupScreenProps {
    stage: MlRuntimeInstallStage;
    error?: string | null;
    onRetry?: () => void;
}

const stageLabel: Record<MlRuntimeInstallStage, string> = {
    checking: 'Checking ML runtime...',
    staging: 'Preparing ML runtime...',
    extracting: 'Installing ML runtime...',
    done: 'ML runtime ready',
    error: 'Installation failed',
};

export default function MlRuntimeSetupScreen({ stage, error, onRetry }: MlRuntimeSetupScreenProps) {
    const isError = stage === 'error';

    return (
        <View style={styles.container}>
            <VStack space={4} style={styles.content}>
                {!isError && <Spinner size="lg" color="emerald.500" />}
                <Heading size="md" textAlign="center">
                    {stageLabel[stage]}
                </Heading>
                <Text textAlign="center" color="gray.500">
                    {isError
                        ? (error || 'An unexpected error occurred. Please retry.')
                        : 'Please wait while the app prepares the ML runtime. This only happens once.'}
                </Text>
                {isError && onRetry && (
                    <Button onPress={onRetry} colorScheme="emerald" mt={2}>
                        Retry
                    </Button>
                )}
            </VStack>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
    },
    content: {
        alignItems: 'center',
        maxWidth: 360,
        paddingHorizontal: 32,
    },
});
